import { type RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'
import { homeRouteRecordRaw, noticeRecordRaw, vipRouteRecordRaw } from './home'
import { hotNewsRouteRecordRaw } from './hotNews'

const routeRecordRaw: RouteRecordRaw[] = [
  ...homeRouteRecordRaw, // 首页模块
  ...hotNewsRouteRecordRaw, // 热门资讯详情
  ...noticeRecordRaw,
  ...vipRouteRecordRaw,
  // ==================================================================
  {
    path: '/author',
    component: Layout,
    redirect: '/author',
    name: 'Author',
    meta: {
      title: '个人空间',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/author/index.vue'),
        name: 'AuthorIndex',
        meta: {
          title: '个人空间',
        },
      },
    ],
  },
  // ==================================================================
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: '登录',
      noTagsView: true,
    },
  },
  // ==================================================================
  {
    path: '/403',
    component: () => import('@/views/error/403.vue'),
    name: 'NoAccess',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true,
    },
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
    name: 'NoFound',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true,
    },
  },
  {
    path: '/500',
    component: () => import('@/views/error/500.vue'),
    name: 'Error',
    meta: {
      hidden: true,
      title: '500',
      noTagsView: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404.vue'),
    name: '',
    meta: {
      title: '404',
      hidden: true,
      breadcrumb: false,
    },
  },
]

export default routeRecordRaw as RouteRecordRaw[]
